import { FiltersOptions } from '../../common/filters.type';
import { useGetFetch } from '../../utils/reactQuery';
import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';

export type FetchRemindersResponseType = FiltersOptions;

export const useGetRemindersFilters = () =>
  useGetFetch<FetchRemindersResponseType>({ url: pathToUrl(ApiRoutesEnum.remindersFilters) });
